import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import SportsPage from "./pages/SportsPage";
import CountriesPage from "./pages/CountriesPage";
import CountryDetailPage from "./pages/CountryDetailPage";
import TeamsPage from "./pages/TeamsPage";
import EventsPage from "./pages/EventsPage";
import SchoolsPage from "./pages/SchoolsPage";
import HealthPage from "./pages/HealthPage";
import HallOfFamePage from "./pages/HallOfFamePage";
import NewsPage from "./pages/NewsPage";
import CommunityPage from "./pages/CommunityPage";
import TeamDetailPage from "./pages/TeamDetailPage";
import LeagueDetailPage from "./pages/LeagueDetailPage";
import SchoolDetailPage from "./pages/SchoolDetailPage";
import SocialPulseCallback from "./pages/SocialPulseCallback";
import CityPage from "./pages/CityPage";
import BusinessPage from "./pages/BusinessPage";
import PublicationsPage from "./pages/PublicationsPage";
import DigestPage from "./pages/DigestPage";
import InboxPage from "./pages/InboxPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import AuthCallback from "./pages/AuthCallback";
import { Toaster } from "./components/ui/sonner";

function AppRouter() {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  if (location.pathname === "/auth/socialpulse/callback") {
    return <SocialPulseCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sports" element={<SportsPage />} />
        <Route path="/countries" element={<CountriesPage />} />
        <Route path="/countries/:countryId" element={<CountryDetailPage />} />
        <Route path="/cities/:cityName" element={<CityPage />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/teams/:teamId" element={<TeamDetailPage />} />
        <Route path="/leagues/:leagueId" element={<LeagueDetailPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/schools" element={<SchoolsPage />} />
        <Route path="/schools/:schoolId" element={<SchoolDetailPage />} />
        <Route path="/health" element={<HealthPage />} />
        <Route path="/halloffame" element={<HallOfFamePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/digest" element={<DigestPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/articles" element={<ArticlesPage />} />
        <Route path="/articles/:articleId" element={<ArticleDetailPage />} />
        <Route path="/community" element={<CommunityPage />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <AppRouter />
            <Toaster position="top-right" />
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
